import {
  GlobalStore,
} from '@roc/feature-app-core';
import { GeneralTasksService, Task, TaskV2 } from '@roc/feature-general-tasks';
import { action, flow, makeObservable, observable } from 'mobx';

export class UnderwriteTheLoanStore {
  private globalStore: GlobalStore;
  private generalTasksService: GeneralTasksService;

  taskV2WithComments: TaskV2[];

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.generalTasksService = new GeneralTasksService();

    this.setDefaults();

    makeObservable(this, {
      taskV2WithComments: observable,
      reset: action,
      loadTasksWithCommentsByLoanId: flow,
    });
  }

  setDefaults() {
    this.taskV2WithComments = [];
  }

  reset() {
    this.setDefaults();
  }

  *loadTasksWithCommentsByLoanId(loanId: number) {
    try {
      const taskListResponse = yield this.generalTasksService.getLoanTasksWithNotes(loanId);
      const taskList = taskListResponse?.data?.data || [];
      const tasksV2WithComments = taskList.filter((t: TaskV2) => t.taskNotes?.length);

      this.taskV2WithComments = tasksV2WithComments;
    } catch (e) {
      console.error(e);
    }
  }
}
